var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorNode1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.75H5.85462C5.55793 13.4829 4.83934 14 4 14C2.89543 14 2 13.1045 2 12C2 10.8954 2.89543 9.99997 4 9.99997C4.83934 9.99997 5.55793 10.517 5.85462 11.25H8.75L11.2929 8.70708C11.6834 8.31655 12.3166 8.31655 12.7071 8.70708L15.25 11.25H18.1454C18.4421 10.517 19.1607 9.99997 20 9.99997C21.1046 9.99997 22 10.8954 22 12C22 13.1045 21.1046 14 20 14C19.1607 14 18.4421 13.4829 18.1454 12.75H15.25L12.7071 15.2929C12.3166 15.6834 11.6834 15.6834 11.2929 15.2929L8.75 12.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorNode1);
export default __webpack_public_path__ + "static/media/vector-node-1.d954e1c31719853c790a09a5700755f5.svg";
export { ForwardRef as ReactComponent };